import { getSaveCards } from "@/services/stripe";
import store from "@/store";

const state = {
  cards: null,
};

const getters = {
  cards: (state) => state.cards,
};

const actions = {
  async getSavedCards({ commit }) {
    try {
      store.commit("showLoading", true);
      const res = await getSaveCards();
      commit("getSavedCards", res.data);
      store.commit("showLoading", false);
    } catch (error) {
      console.log(error);
    }
  },
};

const mutations = {
  getSavedCards: (state, data) => (state.cards = data),
};

export default { state, getters, actions, mutations };
